export const validateSecretCode = (code) => {
  const secretCodes = {
    DonnieTheme: {
      feature: "DONNIE_MODE",
      description: "Donnie Mode theme unlocked! Check your theme toggle.",
    },
    MojoTheme: {
      feature: "MOJO_MODE",
      description: "Mojo Mode theme unlocked! Check your theme toggle.",
    },
    JusticeTheme: {
      feature: "JUSTICE_MODE",
      description: "Justice Mode theme unlocked! Check your theme toggle.",
    },
    OwenTheme: {
      feature: "OWEN_MODE",
      description: "Owen Mode theme unlocked! Check your theme toggle.",
    },
    HanukkahTheme: {
      feature: "HANUKKAH_MODE",
      description: "Hanukkah Mode theme unlocked! Check your theme toggle.",
    },
    ResetThemes: {
      feature: "RESET_THEMES",
      description: "🔄 Themes have been reset to default!",
    },
    PlayBirdGame: {
      feature: "FLAPPY_TRADE_GAME",
      description: "Have fun finding your bird game!",
    },
    PlayWordGame: {
      feature: "STOCK_WORDLE_GAME",
      description: "Stock market word game unlocked!",
    },
    ResetGames: {
      feature: "RESET_GAMES",
      description: "🎮 Games have been reset and hidden.",
    },
  };

  return secretCodes[code] || null;
};

export const activateFeature = (feature) => {
  if (feature === "RESET_THEMES") {
    // Remove all theme features
    localStorage.removeItem("feature_DONNIE_MODE");
    localStorage.removeItem("feature_MOJO_MODE");
    localStorage.removeItem("feature_JUSTICE_MODE");
    localStorage.removeItem("feature_OWEN_MODE");
    localStorage.removeItem("feature_HANUKKAH_MODE");
    localStorage.setItem("theme", "light");
  } else if (feature === "RESET_GAMES") {
    // Remove all game features and scores
    localStorage.removeItem("feature_FLAPPY_TRADE_GAME");
    localStorage.removeItem("feature_STOCK_WORDLE_GAME");
    localStorage.removeItem("flappyHighScore");
    localStorage.removeItem("stockwordle-stats");
    localStorage.removeItem("stockwordle-state");
  } else {
    localStorage.setItem(`feature_${feature}`, "activated");
  }
  window.dispatchEvent(new Event("storage"));
};

export const isFeatureActive = (feature) => {
  return localStorage.getItem(`feature_${feature}`) === "activated";
};

export const getAllActiveFeatures = () => {
  const features = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.startsWith("feature_")) {
      features.push(key.replace("feature_", ""));
    }
  }
  return features;
};
